import React from "react";

const FilterInput = ({title, horizontal="items-center", value, onChange, classname, placeholder, gray=false, disabled = false }) => {
    return(
        <div className={`flex  ${horizontal}  justify-start gap-2`}>
            {title &&
                <p className={`font-itcbook text-[14px]
                    ${disabled ? 'text-gray ' : 'text-[#111928]'} `}>
                    {title}
                </p>
            }
            
            <input 
            type="text"
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
            className={`
                bg-transparent
                focus:outline-none
                ${classname}
                placeholder:text-[14px]
                p-2
                placeholder:font-itcbook
                placeholder:align-middle
                placeholder:text-[#6B7280]
                text-[14px] 
                font-itcbook
                border-[1px]
                rounded-lg
                ${gray ? 'border-[#D1D5DB]' : 'border-blue-light'}
                ${disabled ? 'cursor-not-allowed opacity-50' : ''}
                `}
             />
        </div>
    );
};

export default FilterInput;